export default {
  key: '',
  setItem: function (name, val) {
    try {
      localStorage.setItem('[IRISK][' + this.key + '][' + name + ']', JSON.stringify(val))
    }
    catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  },

  getItem: function (name, def) {
    var val = null
    try {
      val = localStorage.getItem('[IRISK][' + this.key + '][' + name + ']')
      if (val === null) {
        val = (def !== undefined) ? def : ''
      }
      else
      {
        val = JSON.parse(val)
      }
    }
    catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
      val = (def !== undefined) ? def : ''
    }
    return val
  },

  setKey: function (key) {
    this.key = key
  },

  clear: function () {
    localStorage.clear()
  },

  removeItem: function (key) {
    localStorage.removeItem(this.key + key)
  }
}
